module.exports = __webpack_public_path__ + "media/hero.8b5bfe46.wav";